<template>
  <v-row>
    <v-col
      v-for="card in sortedLogoList"
      :key="card.title"
      cols="6"
      sm="3"
      md="2"
      align-self="center"
    >
      <!-- cols="6"  はスマホサイズでの一つのカラムサイズ/sm="2"はそれ以上のブラウザサイズのときのカラムサイズ -->
      <v-img :src="getImageUrl(card.imageUrl2)" class="my-5"></v-img>
    </v-col>
  </v-row>
</template>
<script>
  import CompanyData from "./CompanyData";
  export default {
    data() {
      return {
        logoList: CompanyData.logoList,
      };
    },
    computed: {
      sortedLogoList() {
        return [...this.logoList].sort((a, b) => {
          const sortA = a.sort || ""; // a.sort が存在しない場合は空文字列を代入
          const sortB = b.sort || ""; // b.sort が存在しない場合は空文字列を代入
          return sortA.localeCompare(sortB, "ja", {
            sensitivity: "base",
          });
        });
      },
    },
    methods: {
      getImageUrl(imagePath) {
        return require(`@/assets/${imagePath}`);
      },
    },
  };
</script>
